<template>
  <v-container ma-0 pa-0 >
    <h2>{{$t('feeds.feed_info_title')}}</h2>
    <v-layout row pt-2>
      <v-flex xs5 pt-0>
        <div class="caption mb-1">{{$t('feeds.feed_info_scheduled')}}</div>
      </v-flex>
      <v-flex xs7 pt-0>
        <div class="caption mb-1">{{$t('feeds.feed_info_offset_days')}}</div>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs5>
        <div class="body-2">{{scheduledAt}}</div>
      </v-flex>
      <v-flex xs7>
        <div class="body-2">{{offsetDays}}</div>
      </v-flex>
    </v-layout>
    <v-layout row pt-2>
      <v-flex class="caption truncate " pb-2>
        <div class="caption mb-1 pt-2">{{$t('feeds.feed_info_required_engagement')}}</div>
        <v-icon class="mx-auto" small v-if="requiredEngagement" color="green">mdi-check</v-icon>
        <v-icon class="mx-auto" small v-else="requiredEngagement" color="red">mdi-close</v-icon>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'feed-request-breakdown-info-card',
    computed: {
      ...mapState({
        offsetDays: state => state.feeds.offsetDays,
        scheduledAt: state => state.feeds.scheduledAt,
        requiredEngagement: state => state.feeds.requiredEngagement
      })
    }
  }
</script>

<style scoped>
  .scrollable {
    max-height: calc(100vh - 160px);
    overflow-y: auto;

  }

  .right-text {
    text-align: right;
  }

  @media (max-width: 600px) {
    .scrollable {
      max-height: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/FeedRequestBreakdownInfoCard.vue